import { useQuery } from '@pylot-data/hooks/use-query'
import { getVisualSearchConfig } from './getVisualSearchConfig'

type VisualSearchConfigResponse = {
    config?: {
        base?: {
            pwa?: {
                visual_search_enabled?: boolean | null
            } | null
        } | null
    } | null
}

/**
 * Flag Magento (via Pylot getConfig). `undefined` mientras carga.
 * Solo mostrar la cámara cuando el valor es estrictamente `true`
 * (evita FOUC al apagar desde Admin).
 */
export const useVisualSearchEnabled = (): boolean | undefined => {
    const { data } = useQuery<null, VisualSearchConfigResponse>(
        getVisualSearchConfig,
        null,
        {
            revalidateOnMount: true,
            revalidateOnFocus: true,
            refreshInterval: 30000
        },
        {
            method: 'POST',
            headers: {
                'Cache-Control': 'no-store'
            }
        }
    )

    if (!data?.data) {
        return undefined
    }

    return data.data.config?.base?.pwa?.visual_search_enabled === true
}
